export function MinProcessingIcon({ active }: any) {
  const color: string = active ? "#006AB3" : "#000000";
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.42847 18.5701V17.1417H2.85694V15.7132H1.42847V0H0V18.5701C0 18.949 0.150499 19.3123 0.41839 19.5802C0.68628 19.8481 1.04962 19.9986 1.42847 19.9986H19.9986V18.5701H1.42847Z"
        fill={color}
      />
      <path
        d="M4.28711 15.7129H5.71558V17.1414H4.28711V15.7129ZM7.14405 15.7129H8.57252V17.1414H7.14405V15.7129ZM12.8579 15.7129H14.2864V17.1414H12.8579V15.7129ZM15.7149 15.7129H17.1434V17.1414H15.7149V15.7129ZM18.5718 15.7129H20.0003V17.1414H18.5718V15.7129Z"
        fill={color}
      />
      <path
        d="M18.5316 1.66396L17.1224 1.42969C15.6768 10.0777 13.5798 14.2859 10.7135 14.2859C7.8473 14.2859 5.75031 10.0777 4.3047 1.42969L2.89551 1.66396C3.93544 7.89852 5.68817 14.9502 9.9993 15.6523V17.1429H11.4278V15.6523C15.7396 14.9502 17.4916 7.89852 18.5316 1.66396Z"
        fill={color}
      />
    </svg>
  );
}
